import { render, staticRenderFns } from "./IconRightCircle.vue?vue&type=template&id=40615077"
import script from "./IconRightCircle.vue?vue&type=script&lang=js"
export * from "./IconRightCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports